const Livestream = () => {
   return (
      <svg width="22" height="22" fill="none" viewBox="0 0 22 22">
         <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="1.8" d="M15.583 14.117l4.584-2.2v7.333l-4.584-2.2M12.833 10.083H2.75c-1.013 0-1.833.616-1.833 1.375v8.25c0 .76.82 1.375 1.833 1.375h10.083c1.013 0 1.834-.615 1.834-1.375v-8.25c0-.759-.821-1.375-1.834-1.375zM10.189 6.603a3.525 3.525 0 00-4.986 0M12.183 3.692a6.346 6.346 0 00-8.975 0">
         </path>
      </svg>
   )
}
export default Livestream